var _style, _rect, _path, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewColumnFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,5v14h18V5H3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 7,
    className: "st1",
    width: 2.8,
    height: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 7,
    className: "st1",
    width: 2.8,
    height: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 7,
    className: "st1",
    width: 2.8,
    height: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 7,
    className: "st1",
    width: 2.8,
    height: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewColumnFour);
export default __webpack_public_path__ + "static/media/view_column_four.f7ce003555a4260c88d8d296e622184f.svg";
export { ForwardRef as ReactComponent };